import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { ConfigService } from 'src/app/services/config-service';

@Directive({
  selector: '[imgConverter]'
})
export class ImageSrcConverterDirective implements AfterViewInit {

  @Input() src: string;

  constructor(
    private elementRef: ElementRef,
    private config: ConfigService
  ) { }

  ngAfterViewInit(): void {
    const img = new Image();

    // Create a copy of the src
    let httpsUrl = this.src.slice(0, this.src.length);
    // httpsUrl = httpsUrl.replace("https://keycloak.onnetsystems.ml/", "https://keycloak.onnetsystems.ml/iptvconsole/");
    httpsUrl = httpsUrl.replace(this.config.json.imageUrlPrefix, this.config.json.imageHttpsUrlPrefix);

    //console.log('src: ', this.src);
    //console.log('updated: ', httpsUrl);

    img.onload = () => {
      this.setImage(httpsUrl);
    };

    img.onerror = () => {
      this.setImage(this.src);
    };

    img.src = httpsUrl;
  }

  private setImage(imageSrc: string): void {

    //console.log('src: ', imageSrc);
    this.elementRef.nativeElement.setAttribute('src', imageSrc);
  }

}
